<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas.planosInfantil' })"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano Bimestral Infantil
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn depressed color="primary" @click="() => [visualizarPdf(plano.id), (dialog = true)]">
          Visualizar Pdf
          <v-icon small right> mdi-note </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="12" lg="12">
        <v-card>
          <v-card-text>
            <label for="">Professor</label>
            <v-input>
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.professor
                    ? plano.gestao_de_aula.professor.nome
                    : "- - -"
                  : "- - - "
              }}
            </v-input>

            <label for="">Turma</label>
            <v-input>
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.turma
                    ? plano.gestao_de_aula.turma.descricao
                    : "- - -"
                  : "- - - "
              }}
            </v-input>

            <label for="">Componente Curricular</label>
            <v-input>
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.disciplina
                    ? plano.gestao_de_aula.disciplina.descricao
                    : "- - - "
                  : "- - - "
              }}
            </v-input>

            <label for="">Período</label>
            <v-input>
              <v-chip>
                {{
                  plano.etapa
                    ? plano.etapa.descricao
                      ? plano.etapa.descricao
                      : "- - - "
                    : "- - - "
                }}
              </v-chip>
            </v-input>

            <label for="">Data lançamento</label>
            <v-input>
              <v-chip>
                {{
                  plano.created_at
                    ? plano.created_at.substr(0, 10).split("-").reverse().join("/")
                    : "- - - "
                }}
              </v-chip>
            </v-input>

            <label for="">Ultima atualização</label>
            <v-input>
              <v-chip>
                {{
                  plano.updated_at
                    ? plano.updated_at.substr(0, 10).split("-").reverse().join("/")
                    : "- - - "
                }}
              </v-chip>
            </v-input>
            <v-combobox v-model="seriesSelecionadas" chips label="Series" multiple readonly />
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="2">
                <label for="">Status</label>
                <e-situacao-plano-infantil :plano="plano" v-on:update="listarPlano" />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">EIXOS TEMÁTICOS</label>
                <v-textarea
                  dense
                  color="primary"
                  :value="plano.unidades_tematicas ? plano.unidades_tematicas : '- - -'"
                  readonly
                  hide-details
                  no-resize
                  solo
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label for="">DIREITOS DE APRENDIZAGEM E DESENVOLVIMENTO</label>

                <div v-if="direitosAprendizagemSelecionados.length > 0">
                  <v-chip
                    v-for="(direito, index) in direitosAprendizagemSelecionados"
                    :key="index"
                    class="mt-1 mr-2"
                    color="warning"
                    outlined
                  >
                    {{ direito }}
                  </v-chip>
                </div>
                <div v-else>
                  <v-chip class="ma-1" color="grey" outlined> - - - </v-chip>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label>CAMPOS DE EXPERIÊNCIA</label>
                <div v-if="camposDeExperienciasSelecionadas.length > 0">
                  <v-chip
                    v-for="(experiencia, index) in camposDeExperienciasSelecionadas"
                    :key="index"
                    class="mt-1 mr-2"
                    color="primary"
                    outlined
                  >
                    {{ experiencia }}
                  </v-chip>
                </div>
                <div v-else>
                  <v-chip class="ma-1" color="grey" outlined> - - - </v-chip>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label>OBJETIVOS DE APRENDIZAGEM E DESENVOLVIMENTO</label>
                <div v-if="habilidadesFormatadas.length > 0">
                  <v-card
                    v-for="(habilidade, index) in habilidadesFormatadas"
                    :key="index"
                    class="pa-3 my-2"
                    outlined
                  >
                    <div class="d-flex flex-column">
                      <div class="text-body-2">
                        [ {{ habilidade.apelido }}] - {{ habilidade.descricao }}
                      </div>
                      <v-chip
                        v-if="habilidade.parent?.descricao"
                        small
                        color="primary"
                        class="mt-2 align-self-start"
                      >
                        {{ habilidade.parent.descricao }}
                      </v-chip>
                    </div>
                  </v-card>
                </div>
                <div v-else>
                  <v-chip class="ma-1" color="grey" outlined> - - - </v-chip>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">ABORDAGENS E ESTRATÉGIAS DIDÁTICAS</label>
                <v-textarea
                  dense
                  color="primary"
                  :value="
                    plano.abordagens_estrategias_didaticas
                      ? plano.abordagens_estrategias_didaticas
                      : '- - -'
                  "
                  readonly
                  hide-details
                  no-resize
                  solo
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">RECURSOS (materiais e espaços) </label>
                <div v-if="recursosMateriaisEspacosSelecionados.length > 0">
                  <v-chip
                    v-for="(recurso, index) in recursosMateriaisEspacosSelecionados"
                    :key="index"
                    class="mt-1 mr-2"
                    color="warning"
                    outlined
                  >
                    {{ recurso }}
                  </v-chip>
                </div>
                <div v-else>
                  <v-chip class="ma-1" color="grey" outlined> - - - </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ModalCarteira :dialog="dialog" :pdf="pdf" />
  </main-template>
</template>

<script>
import ModalCarteira from "@/components/Matriculas/EModalCarteira.vue";

export default {
  components: {
    ModalCarteira,
  },
  computed: {
    direitosAprendizagemSelecionados() {
      try {
        const direitos = JSON.parse(this.plano.direitos_aprendizagem || "[]");
        return direitos.filter((item) => item && item.trim() !== "");
      } catch (error) {
        return [];
      }
    },
    camposDeExperienciasSelecionadas() {
      const experiencias = Array.isArray(this.plano.experiencia)
        ? this.plano.experiencia
        : JSON.parse(this.plano.experiencia || "[]");
      return experiencias.filter((item) => item?.trim());
    },

    habilidadesFormatadas() {
      const arr = Array.isArray(this.habilidades)
        ? this.habilidades
        : JSON.parse(this.habilidades || "[]");
      return arr;
    },
    recursosMateriaisEspacosSelecionados() {
      try {
        const recursos = JSON.parse(this.plano.recursos || "[]");
        return recursos.filter((item) => item && item.trim() !== "");
      } catch (error) {
        return [];
      }
    },
  },
  data() {
    return {
      dialog: false,
      pdf: null,
      showSnackbar: false,
      plano: {},
      plano_id: null,
      seriesSelecionadas: [],
      experienciasSelecionadas: [],
      habilidades: [],
      recursosSelecionados: [],
      duvidasSelecionadas: [],
    };
  },
  async mounted() {
    this.getId();
    this.listarPlano(this.pageNumber);
  },
  methods: {
    async getId() {
      const { id } = this.$route.params;
      this.plano_id = id;
    },
    async listarPlano() {
      this.$loaderService.open("Carregando Plano");
      try {
        const { data } = await this.$services.planosService.showInfantil(this.plano_id);

        this.plano = { ...data.planoBimestralInfantil };
        this.seriesSelecionadas = this.plano.gestao_de_aula.turma.series.map((s) => s.descricao);

        this.habilidades = [...data.habilidades];
        this.experienciasSelecionadas = [...data.planoBimestralInfantil.experiencia];
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async carregarDadosAoAtualizarStatus() {
      try {
        this.listarPlano();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async visualizarPdf(planoId) {
      this.pdf = await this.$services.planosService.pdfInfantil(planoId);
    },
  },
};
</script>

<style></style>
